import { render, staticRenderFns } from "./QuestionDetailPage.vue?vue&type=template&id=a6c98b14&scoped=true"
import script from "./QuestionDetailPage.vue?vue&type=script&lang=js"
export * from "./QuestionDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c98b14",
  null
  
)

export default component.exports